module.exports = __webpack_public_path__ + "static/media/fashion-2.a39e2f63.jpg";